export default __webpack_public_path__ + "static/media/greyM.1e3a3bf0.svg";